/** @file Projects browser entry: a new project from a PSD (create, upload, place), then onImported(id). */
import type { Translate } from '@pose2d/i18n/types';
import { useEffect, useMemo, useRef } from 'react';
import { restPorts } from './restPorts';
import { createImportSession } from './createImportSession';
import { FilePicker } from './FilePicker';
import { IMPORT_ACCEPT } from './importAccept.data';
import { ImportDialog } from './ImportDialog';
import { openPsdInWorker } from './openPsdInWorker';
import { projectNameOf } from './projectNameOf';

/** The project name starts as the file name (slugified, `hero-2` when `taken` holds `hero`) and stays editable. */
export function ImportPsdButton({ t, onImported, taken = [] }: { t: Translate; onImported: (projectId: string) => void; taken?: readonly string[] }) {
  const done = useRef(onImported);
  done.current = onImported;
  const session = useMemo(
    () => createImportSession({ ports: restPorts(() => Promise.resolve()), openPsd: (bytes) => openPsdInWorker(bytes), afterImport: (o) => { done.current(o.projectId); return Promise.resolve(); } }),
    [],
  );
  useEffect(() => () => { session.dispose(); }, [session]);
  return (
    <>
      <FilePicker
        label={t('psdImport.newFromPsd')}
        accept={IMPORT_ACCEPT.psd}
        multiple={false}
        onFiles={(files) => { const [file] = files; if (file !== undefined) void session.openPsd(file, { kind: 'newProject', name: projectNameOf(file.name, taken) }); }}
      />
      <ImportDialog t={t} session={session} />
    </>
  );
}
